import { Button, Typography } from "@mui/material";
import { styled } from "styled-components";

// Styled Components
export const PageContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: 100vh;
  background-color: #f8f9fa;
  padding: 20px;
`;

export const ContentWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  padding: 40px 20px;
  border-radius: 8px;
  background: white;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
  width: 100%;
  max-width: 400px;
`;

export const NotFoundImage = styled.img`
  max-width: 100%;
  height: auto;
  margin-bottom: 24px;
`;

export const Title = styled(Typography).attrs({
  variant: "subtitle1",
})`
  font-size: 1.1rem;
  color: #333;
  margin-bottom: 24px !important;
  font-weight: 500;
`;

export const HomeButton = styled(Button).attrs({
  variant: "contained"
})`
  && {
    box-shadow: none;
    border: 1px solid #E2E2E2;
    text-transform: none;
    padding: 8px 24px;
    font-weight: 500;
    
    &:hover {
      box-shadow: none;
      opacity: 0.9;
    }
  }
`;